
/* injects from baggage-loader */

'use strict';
import regions from './tab-device-chef.const';
import { PlatesType } from '../types/plates';

import _ from 'lodash/core';

import { chain } from 'lodash';

import { genSecureHex } from '../../../core/services/secure-random';

export default class tabDeviceChefController {
    constructor($log, $rootScope, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.Dialog = Dialog;
        this.tabState = 0;
        

        this.tabs = [
            {
                title: "Entrada",
                index: 1
            },
            {
                title: "Prato Principal",
                index: 2
            },
            {
                title: "Sobremesa",
                index: 3
            },
            {
                title: "Bebidas",
                index: 4
            }  
        ]

        this.state = {
            step: 0,
            reset: false,
            confirm: false,
        }

        //textos customizaveis

		this.title = {
			word:"Nome do restaurante",
			editorEnabled:false,
			editableWord:"",
			placeholder: "Nome do restaurante" 
        };
        
        this.words = [
			{
                word: [], 
                editorEnabled: [], 
                editableWord: "", 
                editableWordAux: [],            //as palavras são salvas aqui
                placeholder: "Escreva algo", 
                placeholderNum: "Escreva preço",
                current: []                     //aqui é o índice usado pra exibir ou não na tela
            },
        ];
        
        this.$rootScope.$on('setListTitle', (event, data) => { 
            this.title.word = data;
			this.title.editorEnabled = false;
			this.title.editableWord = "";
			this.title.placeholder = data;
        });

        this.temp = "";

        //controle
        this.print = false;

        //recebendo informação pratos

        this.tabContent = {
            words: []
        }

        this.$rootScope.$on('setPratos', (event, data) => { 
            this.setTabContents(data[0], data[1]);
        });

        this.liberado = false;

        this.$rootScope.$on('start2:countdown', (event, data) => { 
            $log.log(data)
            this.liberado = data;
        });
        
    }

    $onInit(){
        this.setRegion();
        this.$rootScope.$on('reset:stage', this.resetStage.bind(this));
    }

    setRegion(){        
        this.device = regions[this.region].device;
        this.model.items = regions[this.region].order;
        this.genItemIds();
    }

    //gera id pros itens
    genItemIds(){
        this.model.items.forEach(item => {
            item._id = genSecureHex();
        });
    }

    setCurrentTab(index){
        this.tabState = index;
        this.$rootScope.$emit('setCurrentTabDevice',index);
    }

    // calc total order
    total(){
        return chain(this.model.items)
                .map(item => item.value ? item.value.price : 0.0)
                .sum()
                .value()
    }

    triggerResetStage(){
        this.toggleReset();
        this.$rootScope.$emit('reset:stage');
    }

    triggerConfirm(){        
        this.toggleConfirm();
        this.onSubmit();        
    }

    toggleConfirm(){            
        this.state.confirm = !this.state.confirm;
        
        if(!this.state.confirm){
            this.state.step = 0;
        }
    }
    
    toggleReset(){
        this.state.reset = !this.state.reset;
        
        if(!this.state.reset){
            this.state.step = 0;
        }
    }

    toConfirmation(){
        if(this.isEmpty()) return this.openEmpty();
        this.state.step = 1;
    }
    
    resetStage(){
        this.model.items.map(this.resetMap);

        for (let i = 0; i < this.tabContent.words.length; i++){
            this.tabContent.words[i] = '';
        }
    }

    resetMap(item){
        item.value = null;
        return item;
    }

    renderItemType(item){
        switch (item.type) {
            case PlatesType.entrance:
                return "Entrada"
            case PlatesType.principal:
                return "Prato Principal"
            case PlatesType.dessert:
                return "Sobremesa"
            case PlatesType.drink:
                return "Bebida"            
        }
    }

    onDrop(event, data, item, index){
        if (this.liberado){
            if(!item.value){
                let aux = index;

                item.value = data;
                this.$rootScope.$emit('tabdevice:drop:success', item.value);

                //enviando sinal
                if (aux % 2 === 0)
                    this.$rootScope.$emit('setPratos', [item.value.title, aux]);
                else
                    this.$rootScope.$emit('setPratos', [item.value.price, aux]);

            }
            return true;
        }
        
    }

    openEmpty(){
        let msg = 'Você ainda não escolheu nenhum item para o seu pedido!';
        let type = 'fail';
        
        this.Dialog.showFeedback(msg, type, () => false);
        return false;
    }

    dropValidate(item, data){
        return item.type === data.type;
    }

    isEmpty(){
        return chain(this.model.items).filter({ value: null}).size().value() === this.model.items.length;
    }

    //edição de texto customizavel

    enableEditorTitle(w) {
		if(!this.print){
            w.editorEnabled = true;
			if(w.word === w.placeholder)
				w.editableWord = "";
			else
				w.editableWord = w.word;
		}
    }

    enableEditor($event, w) {
        if (this.liberado){
            if(!this.print){
                let aux = $event.currentTarget.attributes['data-id-span'].value;

                w.editorEnabled[aux] = true;
                w.current[aux] = aux;
                if(w.word[aux] === w.placeholder || w.word[aux] === '')
                    w.editableWordAux[aux] = "";
                else{
                    w.editableWordAux[aux] = w.word[aux];
                }
            }
        }
		
    }

	addItem() {
		if(this.words.length < 10)
			this.words.push({word: "Escreva algo", editorEnabled:false, editableWord:"", placeholder: "Escreva algo"});
    }
    
    nextTitle(w){
		if(w.editableWord !== ""){
			w.word = "Restaurante " + w.editableWord;
			if(this.words[0].word === this.words[0].placeholder)
				this.words[0].editorEnabled = true;
		} else {
			w.word = w.placeholder;
        }
        
		w.editorEnabled = false;
    }
    
    next(event, w, index){
        let aux = event.currentTarget.attributes['data-id-span'].value;

		if(w.editableWord !== ""){
			if(_.isUndefined(this.words[index+1])){
                w.word[aux] = w.editableWord;
                
            }
		} else {
			w.word[aux] = w.placeholder;
        }
        
        w.editorEnabled[aux] = false;

        //mandando o sinal
        
        this.$rootScope.$emit('setPratos', [w.editableWordAux[aux], aux]);
    }

    isNumber(num){
        return !isNaN(parseFloat(num)) && isFinite(num);
    }

    //salvando os pratos pra uso na fase

    savePratos(){
        this.$rootScope.$emit('showOptions', true);
	}
    
    //controlando os textos

    setTabContents(word, index){
        if (index % 2 === 0)
            this.tabContent.words[index] = word + this.separador;
        else
            this.tabContent.words[index] = word;
    }

    checkValid(){
        let aux = this.tabContent.words; 

        if (aux[0] && aux[1] && aux[6] && aux[7] && aux[12] && aux[13] && aux[18] && aux[19])
            return true;
        else
            return false;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/ui/tab-device-chef/tab-device-chef.controller.js